import type { BrandOnboardingMode } from "@runcheetah/shared";

import { buildBrandPath, isBrandReadyForApp } from "@/hooks/use-route-brand";

type BrandStatus = "queued" | "processing" | "scanned" | "failed";

export interface AppPageBrandRouteState {
  id: string;
  status: BrandStatus;
  onboardingMode?: BrandOnboardingMode;
  onboarding?: {
    completion: {
      firstAssetReady: boolean;
    };
  };
}

export type AppPageRouteDecision =
  | { kind: "first_onboarding"; brandId: string | null }
  | { kind: "redirect"; to: string };

const isReadyForApp = (brand: AppPageBrandRouteState): boolean =>
  isBrandReadyForApp({
    status: brand.status,
    onboardingMode: brand.onboardingMode,
    firstAssetReady: brand.onboarding?.completion.firstAssetReady,
  });

export const getAppPageRouteDecision = (brands: AppPageBrandRouteState[]): AppPageRouteDecision => {
  if (brands.length === 0) {
    return { kind: "first_onboarding", brandId: null };
  }

  if (brands.length === 1) {
    const [brand] = brands;
    if (!brand) {
      return { kind: "first_onboarding", brandId: null };
    }

    if (!isReadyForApp(brand)) {
      return { kind: "first_onboarding", brandId: brand.id };
    }

    return { kind: "redirect", to: buildBrandPath(brand.id, "/pulse") };
  }

  const readyBrand = brands.find(isReadyForApp);
  if (readyBrand) {
    return { kind: "redirect", to: buildBrandPath(readyBrand.id, "/pulse") };
  }

  const [brand] = brands;
  if (!brand) {
    return { kind: "first_onboarding", brandId: null };
  }

  return { kind: "redirect", to: buildBrandPath(brand.id, "/onboarding") };
};
